// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/transportation/reports/noon.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { DateRangeRequest, EmptyRequest, EmptyResponse } from "../../../common/messages/messages";
import {
  GetManagementResponse,
  GetNoonReportV202005Response,
  GetVesselReportV202205Response,
  NoonReportV202005,
  NoonReportV202005Request,
  NoonReportV202005Response,
  UpdateNoonReportV202005Request,
  VesselReportV202205,
} from "./noon";

import { NoonReportServiceClientImpl } from "./noon";

@Injectable({ providedIn: "root" })
export class NoonReportServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async getNoonReportsV202005Between(request: DateRangeRequest): Promise<GetNoonReportV202005Response> {
    const client = new NoonReportServiceClientImpl(this._rpc);
    return await client.getNoonReportsV202005Between(request);
  }
  async getNoonReportsV202205Between(request: DateRangeRequest): Promise<GetVesselReportV202205Response> {
    const client = new NoonReportServiceClientImpl(this._rpc);
    return await client.getNoonReportsV202205Between(request);
  }
  async getNoonReportsV202005Excel(request: NoonReportV202005Request): Promise<NoonReportV202005Response> {
    const client = new NoonReportServiceClientImpl(this._rpc);
    return await client.getNoonReportsV202005Excel(request);
  }
  async getLatestNoonReportsV202005(request: EmptyRequest): Promise<GetNoonReportV202005Response> {
    const client = new NoonReportServiceClientImpl(this._rpc);
    return await client.getLatestNoonReportsV202005(request);
  }
  async getLatestManagementReport(request: EmptyRequest): Promise<GetManagementResponse> {
    const client = new NoonReportServiceClientImpl(this._rpc);
    return await client.getLatestManagementReport(request);
  }
  async updateNoonReportV202005(request: UpdateNoonReportV202005Request): Promise<NoonReportV202005> {
    const client = new NoonReportServiceClientImpl(this._rpc);
    return await client.updateNoonReportV202005(request);
  }
  async updateNoonReportV202205(request: VesselReportV202205): Promise<EmptyResponse> {
    const client = new NoonReportServiceClientImpl(this._rpc);
    return await client.updateNoonReportV202205(request);
  }
}
